import {DatePipe} from '@angular/common';
import {Component, ViewChild} from '@angular/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {IntegradorService} from '../../../../services/integrador.service';
import {ToastService} from '../../../../services/toast.service';
import {Instancia} from '../../../../types/Instancia.type';
import {Provisao} from '../../../../types/Provisao.type';
import {Table} from 'primeng/table';

@Component({
  selector: 'app-provisao',
  templateUrl: './provisao.component.html',
  styleUrl: './provisao.component.css',
  providers: [DatePipe, ConfirmationService],
})
export class ProvisaoComponent {
  @ViewChild('dt') table!: Table;
  iconeCheckbox: string = "T"

  itensReversao: MenuItem[];

  quantidadePorPagina: number = 20;
  status: any[] = [{name: 'Integrado', value: 'IT'}
    , {name: 'Pendente Integração', value: 'NI'}
    , {name: 'Estornado', value: 'ES'}
    , {name: 'Cancelado', value: 'CA'}
    , {name: 'Erro', value: 'ER'}
  ]

  provisoes: Provisao[] = [];
  loading: boolean = false;
  loadingSincronizar: boolean = false;
  instancias: Instancia[] = [
    {id: 'VALE', nome: 'VALE'},
    {id: 'UCP', nome: 'UCP'},
    {id: 'UVP', nome: 'UVP'},
  ];
  instanciaSelecionada!: string;
  rangeDates!: string;
  provisoesSelecionadas: Provisao[] = []

  todosRegistrosSelecionados: boolean = false;
  selecionados: boolean = false;

  constructor(
    private integradorService: IntegradorService,
    private toastService: ToastService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService
  ) {
    this.itensReversao = [
      {
        label: 'Cancelar',
        command: () => {
          this.cancelar();
        },
      },
      {
        label: 'Estornar no PIMS',
        command: () => {
          this.estornar();
        },
      },
    ];
  }

  ngOnInit(): void {
    this.getProvisoes();
  }

  getProvisoes() {
    this.provisoes = [];

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      this.loading = true;

      this.integradorService
        .getProvisoes(this.instanciaSelecionada, dataInicial, dataFinal)
        .subscribe({
          next: (data) => {
            this.provisoes = []
            this.provisoes = data;
            this.provisoesSelecionadas = [];
          },
          error: (error) => {
            this.loading = false;
            this.toastService.erro(
              'Erro',
              'Erro ao buscar as informações: ' + error.error.message
            );
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
    }
  }

  sincronizar() {
    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      this.loadingSincronizar = true;

      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      this.integradorService
        .sincronizaProvisoes(this.instanciaSelecionada, dataInicial, dataFinal)
        .subscribe({
          next: (data) => {
            this.toastService.sucesso('Sucesso', 'Busca realizada');
            this.provisoes = [];
            this.getProvisoes();
            this.provisoesSelecionadas = [];
          },
          error: (err) => {
            this.loadingSincronizar = false;
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingSincronizar = false;
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
    }
  }

  integrar() {
    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined &&
      this.provisoesSelecionadas.length > 0
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      if (this.provisoesSelecionadas.filter(pv => pv.fgStatusInteg == 'IT').length > 0) {
        this.toastService.alerta("Integrada", 'Existem provisões selecionadas que já foram integradas, favor verificar');

        return;
      }

      this.loadingSincronizar = true;

      let ids = this.provisoesSelecionadas.map(m => m.idProv)

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      this.integradorService.integrarProvisoes(corpo).subscribe({
        next: (value) => {
          this.toastService.sucesso('Sucesso', 'Integração realizada');
          this.provisoes = [];
          this.getProvisoes();
        },
        error: (err) => {
          this.loadingSincronizar = false;
          this.toastService.erro(
            'Erro',
            'Erro na solicitação: ' + err.error.message
          );
        },
        complete: () => {
          this.loadingSincronizar = false;
        },
      });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários e/ou selecione os registros');
    }
  }

  getStatus(status: string): string {
    let stt = '';

    switch (status) {
      case 'IT':
        stt = 'Integrado';
        break;
      case 'IP':
        stt = 'Enviando ao PIMS';
        break;
      case 'AP':
        stt = 'Aguardando Provisão';
        break;
      case 'IE':
        stt = 'Enviando ao ERP';
        break;
      case 'ER':
        stt = 'Erro';
        break;
    }

    return stt;
  }

  getSeverity(status: string): string {
    let stt = '';

    switch (status) {
      case 'IT':
        stt = 'success';
        break;
      case 'ER':
        stt = 'danger';
        break;
      default:
        stt = 'info';
        break;
    }

    return stt;
  }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform(data, 'yyyy-MM-dd');
  }

  exportar() {
    if (
      this.instanciaSelecionada == undefined
    ) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }


    if (this.provisoesSelecionadas.length > 0) {
      this.loading = true;

      let ids = this.provisoesSelecionadas.map(m => m.idProv)

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      this.integradorService
        .exportarProvisoes(
          corpo
        )
        .subscribe({
          next: (value) => {
            const url = window.URL.createObjectURL(value);
            const a = document.createElement('a')
            a.href = url
            a.download = 'data.xlsx'
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          },
          error: (error) => {
            this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
          },
          complete: () => {
            this.loading = false;
          },

        });


    } else {
      this.toastService.info("Exportar", 'Necessário selecionar os registros que devem ser exportados');
    }
  }

  cancelar() {
    if (
      this.provisoesSelecionadas.filter((ad) => ad.fgStatusInteg != 'IT' && ad.fgStatusInteg != 'NI' && ad.fgStatusInteg != 'ER').length >
      0 ||
      this.provisoesSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.provisoesSelecionadas.map((m) => m.idProv);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    console.log(corpo);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.integradorService.postCancelarProvisao(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Cancelamento realizado');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loading = false;
            this.getProvisoes();
            this.provisoesSelecionadas = [];
          },
        });
      },
    });
  }

  estornar() {
    if (
      this.provisoesSelecionadas.filter((ad) => ad.fgStatusInteg != 'CA').length >
      0 ||
      this.provisoesSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros cancelados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.provisoesSelecionadas.map((ad) => ad.idProv);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja estornar os itens selecionados no PIMS? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.integradorService.postEstornarProvisao(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Estorno realizada');
          },
          error: (err) => {
            console.error(err)
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error
            );
          },
          complete: () => {
            this.loading = false;
            this.getProvisoes();
            this.provisoesSelecionadas = [];
          },
        });
      },
    });
  }

  selecionarRegistros(event: any) {

    if (event.checked) {
      if (!this.table) return;
      if (this.provisoes.length > 0) {

        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.provisoes.length);

        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro);

        this.provisoesSelecionadas = this.provisoesSelecionadas.filter(prov => !dadosFiltradosOrdenados.includes(prov))
        this.provisoesSelecionadas = [...this.provisoesSelecionadas, ...dadosFiltradosOrdenados]
      }

    } else {

      if (this.provisoesSelecionadas.length == this.provisoes.length) {
        this.provisoesSelecionadas = []
      } else {
        // Limpa apenas os registros visiveis na pagina atual
        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.provisoes.length);

        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro)
        this.provisoesSelecionadas = this.provisoesSelecionadas.filter(prov => !dadosFiltradosOrdenados.includes(prov))
      }
    }
    this.defineIconeCheckBox()
  }


  defineIconeCheckBox() {
    if (!this.table) return;

    if (this.provisoes.length > 0) {
      let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

      const primeiroRegistro = this.table.first ?? 0;
      const linhasPorPagina = this.table.rows ?? 0;
      const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.provisoes.length);

      const resultado = this.compareArrays(dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro), this.provisoesSelecionadas);

      if (this.provisoesSelecionadas.length == dadosFiltradosOrdenados.length || this.provisoesSelecionadas.length == this.provisoes.length) this.iconeCheckbox = "Todos"
      else if (resultado != "Nenhum") this.iconeCheckbox = "Parcial"

      else this.iconeCheckbox = "Nenhum"

      if (this.iconeCheckbox !== "Nenhum") this.selecionados = true
      else this.selecionados = false

    } else {
      this.iconeCheckbox = "Nenhum"
      this.selecionados = false
    }
  }


  onPageChange(event: any) {

    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  compareArrays<T>(arrayA: T[], arrayB: T[]): 'Todos' | 'Parcial' | 'Nenhum' {

    if (arrayA.length === 0) return 'Nenhum';

    const setB = new Set(arrayB);
    const countInB = arrayA.filter(item => setB.has(item)).length;

    if (countInB === 0) return 'Nenhum';           // Nenhum
    if (countInB === arrayA.length) return 'Todos'; // Todos
    return 'Parcial';                                // Alguns (parcial)
  }


  /**
   * Handler quando seleção muda
   */
  onSelectionChange() {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  /**
   * Handler de filtro
   */
  onFilter(event: any) {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  selectionarTodos(){

    this.provisoesSelecionadas = [...this.provisoes]
    this.defineIconeCheckBox()

  }
}
